import { I as Icon, d as defineCustomElement$1 } from './p-C0QfdhKo.js';

const WangsIcon = Icon;
const defineCustomElement = defineCustomElement$1;

export { WangsIcon, defineCustomElement };
